import { mapActions, mapGetters } from "vuex";
import handleNextField from "@utils/handle-next-field";
import stringSanitize from "@utils/string-sanitize";
import { getRouteNameParsed } from "@utils/getRouteNameParsed";
// import goToWithScroll from "../utils/go-to-with-scroll";
// import scrollBy from "../utils/scroll-by";

export const defaultField = {
  component: null,
  attrs: {
    label: "",
    name: "",
  },
  options: [],
  validation: {},
  errorMessages: [],
};

export const FormMixinDefault = {
  data() {
    return {
      generalError: false,
      messageError: "",
      data: {},
      lastMessageSent: {},
    };
  },
  updated() {
    // if (!this.$v.$anyError) {
    //   goToWithScroll.call(this, scrollBy);
    // }
  },
  mounted() {
    this.data = this.fields.reduce(
      (prev, field) => ({
        ...prev,
        [field.attrs.name]:
          field.attrs.value !== undefined && field.attrs.value !== null
            ? field.attrs.value
            : "",
      }),
      {}
    );

    this.fetchData();
  },
  computed: {
    ...mapGetters({
      getRouteName: "getRouteName",
    }),
    fieldsWithDefaults() {
      return this.fields.map(x => ({ ...defaultField, ...x }));
    },
    getMessageError() {
      return this.messageError === ""
        ? "Não conseguimos concluir a requisição, tente novamente."
        : this.messageError;
    },
  },
  methods: {
    ...mapActions({
      fetchApi: "api",
    }),
    handleNextField: (e, options, validation, mask) =>
      handleNextField(e, options, validation, mask),
    async submit() {
      this.$v.$touch();
      if (this.$v.$error) return;
      this.handleSubmit();
    },
    formUtils() {
      async function fetch(entity, action, payload, callbackFunc = () => {}) {
        try {
          if (!payload)
            throw new Error("parametro 'payload' não pode ser vazio!");
          if (!entity)
            throw new Error("parametro 'entity' não pode ser vazio!");
          if (!action)
            throw new Error("parametro 'action' não pode ser vazio!");

          const { data } = await this.fetchApi({
            entity,
            action,
            payload,
          });
          callbackFunc({ ...data });
          return { retorno: { ...data }, error: false };
        } catch (err) {
          callbackFunc({ retorno: err, error: true });
          return { retorno: { ...err }, error: true };
          // throw new Error(err);
        }
      }

      async function goToNextPage(UrlRedirect) {
        try {
          this.$router.push({
            path: UrlRedirect,
            query: this.$route.query,
          });
        } catch (error) {
          throw new Error(error);
        }
      }

      return {
        fetch,
        goToNextPage,
      };
    },

    getRouteNameFromURL() {
      const url = new URL(window.location.href);
      const pathName = url.pathname;
      return getRouteNameParsed(pathName, true);
    },

    sendEventViewedField(fieldName) {
      const routeName = this.getRouteNameFromURL();
      const baseEvent = {
        component: "form",
        step: routeName,
        value: 0,
      };
      let description = fieldName;
      let action = "view-success";
      if (this.$v.data[fieldName].$invalid && this.$v.data[fieldName].$dirty) {
        const item = this.fieldsWithDefaults.find(
          item => item.attrs.name === fieldName
        );
        const errorKey = Object.keys(this.$v.data[fieldName].$params).find(
          key => key !== null
        );
        const errorMessage = item.errorMessages.find(
          error => error.name === errorKey
        ).message;
        action = "view-error";
        description += `:${stringSanitize(errorMessage)}`;
      }
      if (this.lastMessageSent[fieldName] === description) return;

      this.$gtm.sendViewEvent("user_view", {
        ...baseEvent,
        action,
        description,
      });

      this.lastMessageSent[fieldName] = description;
    },
  },

  watch: {
    // "$v.data.$model": {
    //   handler: function() {
    //     const fields = Object.keys(this.$v.data).filter(
    //       field => !field.includes("$")
    //     );
    //     const routName = getRouteNameParsed(this.getRouteName);
    //     // const $this = this;
    //     fields.forEach(field => {
    //       const baseEvent = {
    //         component: "form",
    //         step: routName,
    //         value: 0,
    //       };
    //       let description = field;
    //       let action = "view-success";
    //       if (this.$v.data[field].$invalid && this.$v.data[field].$dirty) {
    //         const item = this.fieldsWithDefaults.find(
    //           item => item.attrs.name === "telefone"
    //         );
    //         const errorKey = Object.keys(this.$v.data[field].$params).find(
    //           key => key !== null
    //         );
    //         const errorMessage = item.errorMessages.find(
    //           error => error.name === errorKey
    //         ).message;
    //         action = "view-error";
    //         description += `:${stringSanitize(errorMessage)}`;
    //       }
    //       if (this.lastMessageSent[field] === description) return;
    //       this.$gtm.sendViewEvent("user_view", {
    //         ...baseEvent,
    //         action,
    //         description,
    //       });
    //       this.lastMessageSent[field] = description;
    //     });
    //   },
    //   deep: true,
    // },
    // isFormSubmit() {
    //   this.submit();
    // },
  },
  validations() {
    const data = this.fieldsWithDefaults
      .filter(x => x.validation)
      .reduce(
        (prev, field) => ({
          ...prev,
          [field.attrs.name]: field.validation,
        }),
        {}
      );
    return { data };
  },
};
